<div
  app-modal-content
  class="flex flex-col rounded-none! lg:rounded-2xl! md:max-h-[90vh] w-screen overflow-hidden md:overflow-y-auto lg:max-h-[60rem] lg:w-[95rem]"
>
  <div class="flex p-6 rounded-none! items-center relative lg:rounded-2xl">
    <h1 class="w-full text-center text-3xl font-semibold text-modules-eclass-500">{{ data.title }}</h1>
    <button type="button" app-icon-button dialogClose class="p-0!">
      <svg-icon
        class="absolute h-10 w-10 select-none text-modules-eclass-500"
        src="assets/icons/icon-close-fine.svg"
      ></svg-icon>
    </button>
  </div>
  <div
    class="px-4 py-6 rounded-3xl overflow-y-auto h-[calc(var(--vh)-10rem)] md:h-full shadow-[inset_0_2px_8px_rgba(0,0,0,0.15)]"
  >
    @if (groupings() | isEmpty) {
      <div class="ml-2 animate-pulse">
        <div class="h-8 w-96 rounded bg-[#dedfe3]"></div>
      </div>

      <div class="flex flex-wrap gap-8">
        <app-skeleton class="h-96! w-80!"></app-skeleton>
        <app-skeleton class="h-96! w-80!"></app-skeleton>
        <app-skeleton class="h-96! w-80!"></app-skeleton>
        <app-skeleton class="h-96! w-80!"></app-skeleton>
      </div>
    } @else {
      @for (grouping of groupings(); track $index) {
        <div>
          <h6 class="text-md font-semibold text-base-whisper-800">{{ grouping.description }}</h6>
        </div>
        <div class="flex flex-wrap gap-8">
          @for (book of grouping.books; track book.uuid) {
            <app-card-list
              class="min-h-[25rem] pb-5"
              (click)="onOpenBook(book)"
              containerStyle="hover:border-modules-educational-materials-500"
            >
              <img app-img class="h-full max-h-[18rem] select-none" [src]="book?.image" />
              <div app-label class="flex flex-col justify-center truncate text-center">
                <h4 class="truncate pt-4 text-sm font-bold text-base-whisper-900">{{ book?.title }}</h4>
                <h5 class="truncate text-base-whisper-900">{{ book?.fasciculo }}</h5>
              </div>
            </app-card-list>
          }
        </div>
      }
    }
  </div>
  @if (!!logo()) {
    <div class="flex w-full px-6 pt-6 justify-center text-gray-300">
      <svg-icon class="w-10 block" [src]="logo()"></svg-icon>
    </div>
  }
</div>
